import styled from 'types/theme.types';
import { useHasPermission } from 'hooks/use-has-permission';
import { useIntl } from 'react-intl';
import type { Credential } from 'types/api.types';
import EditIcon from 'components/common/edit-icon';

type ProjectSettingsCredentialsSelectorOptionProps = {
  credential: Credential;
  showFullName: boolean;
  onEditClick?: (credential: Credential) => void;
};

export const ProjectSettingsCredentialsSelectorOption: React.FC<ProjectSettingsCredentialsSelectorOptionProps> = ({
  credential,
  showFullName,
  onEditClick
}) => {
  const intl = useIntl();
  const { isAuthorized: hasPermission, isLoading: isLoadingPermissions } = useHasPermission('MANAGE_CREDENTIALS', {
    projectId: credential.projectId,
    skipProjectCheck: !credential.projectId
  });

  return (
    <Container>
      <Name>
        {showFullName
          ? `${credential.name} (${intl.formatMessage({
              id: `projects.settings.menu.credentials.provider.${credential.type}`
            })})`
          : credential.name}
      </Name>
      {hasPermission && !isLoadingPermissions && (
        <StyledEditIcon
          onClick={e => {
            e.stopPropagation();
            onEditClick?.(credential);
          }}
          data-e2e={`update-credential-${credential.id}`}
        />
      )}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  gap: var(--spacing-md);

  overflow: hidden;
`;

const Name = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StyledEditIcon = styled(EditIcon)`
  height: 12px;
  width: 12px;
`;
